import { updatesData } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {updatesData.title}
        </h2>
        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
          {updatesData.items.map((item, i) => (
            <div key={i} className="relative mb-8 last:mb-0">
              <div className="absolute -left-[29px] md:-left-[33px] top-0 w-[14px] h-[14px] rounded-full bg-primary-500 border-4 border-background-50"></div>
              <div className="flex items-center gap-2 mb-1 flex-wrap">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}